<template>
  <div class="history">
    <v-base-card>
      <template v-slot:heading>
        お知らせ {{actionName}}
      </template>

      <template v-slot:content>
        <v-notification-form @submit="submit" />
      </template>
    </v-base-card>
  </div>
</template>

<script>
import VBaseCard from '@/components/molecules/BaseCard'
import VNotificationForm from '@/components/organizms/NotificationForm.vue'

export default {
  components: {
    VBaseCard,
    VNotificationForm,
  },

  beforeDestroy() {
    this.$store.commit('notification/initialize')
  },

  computed: {
    actionName() {
      return this.$store.getters['notification/actionName']
    },
  },

  methods: {
    async submit() {
      const res = await this.$store.dispatch('notification/submit')
      this.$toasted.global.success({ message: res.message })
      this.$router.push('/admin/notifications')
    }
  }
}
</script>

<style lang="stylus" scoped>
.title__filed
  margin-left 30px

.message__field
  font-size 14px !important
</style>
